// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
require('./_set-collection-from')('Map');



//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/node_modules/core-js/library/modules/es7.map.from.js
// module id = 1769
// module chunks = 0 4 5 6 7 8 10 11 13 17 18 19